import { v4 as uuidv4 } from 'uuid';
import { TodoList } from '../../types/types';

export const DEFAULT_LISTS: TodoList[] = [
    { id: uuidv4(), title: 'Todo List', todos: [] },
    { id: uuidv4(), title: 'In Progress', todos: [] },
    { id: uuidv4(), title: 'Done', todos: [] },
];

export const STORAGE_KEY_WORKSPACES = 'todo_workspaces';
export const STORAGE_KEY_TODO_LISTS = 'todo_lists';
export const STORAGE_KEY_TODOS = 'todo_todos';

export const API_PREFIX_WORKSPACES = '/workspace';
export const API_PREFIX_TODO_LISTS = '/todoList';
export const API_PREFIX_TODOS = '/todo';
